import {LinePlotSettings} from '../WorkspaceDrawer/Settings/types';
import {useLinePlotTemplateSections} from './runLinePlots/useLinePlotSections';
import {WorkspaceTemplate} from './workspaceTemplatesQueries';

/**
 * This hook is used in both the template drawer and the user settings page.
 * In both pages, we want to display the same data; however, the template
 * drawer needs to handle strikethrough old values when relevant.
 */
export const useTemplateSections = ({
  workspaceTemplate,
  currWorkspaceLinePlotSettings,
}: {
  workspaceTemplate: WorkspaceTemplate;
  currWorkspaceLinePlotSettings?: LinePlotSettings;
}) => {
  const linePlotTemplateSections = useLinePlotTemplateSections({
    currTemplateLinePlotSettings: workspaceTemplate?.linePlotSettings,
    currWorkspaceLinePlotSettings,
  });

  return [...linePlotTemplateSections];
};
